import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonServiceService } from '../../services/common-service.service';
import { SnackBarComponent } from 'src/app/shared/snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ContentService } from 'src/app/shared/services/content.service';
import { environment } from '../../../../environments/environment';
import { forkJoin, of } from 'rxjs';
declare function makeFormioIpsa(
  args: any, args2: any, args3: any, updateLoader: (isLoading: any) => void,
  updateMessage: (isLoading: any) => void, baseUrl: string, readOnly?: boolean
): any;
declare function postFormData(args1: any, args2: any): any;

@Component({
  selector: 'app-ipsa-form-design',
  templateUrl: './ipsa-form-design.component.html',
  styleUrls: ['./ipsa-form-design.component.scss']
})
export class IpsaFormDesignComponent implements OnInit {
  readonly ADMIN_USER_LEVEL = 1;

  jwtToken: any;
  urlData: any;
  formFetchResponse: any;
  formSubmissionData: any;
  formioipsa: any;
  isViewMode = false;
  formFetchResponseComponent: any;
  formTitle = '';

  prefilledData: any;
  showFormName: any;
  listingParams: any;

  userData: any = JSON.parse(sessionStorage.getItem('userdata') || '{}');

  get isReadOnly(): boolean {
    return this.userData?.userlevel_id === this.ADMIN_USER_LEVEL || this.urlData?.editMode === 'viewMode';
  }

  constructor(
    private commonService: CommonServiceService, public router: Router, private route: ActivatedRoute,
    private snackBar: MatSnackBar, private contentService: ContentService
  ) {
    this.route.queryParams.subscribe(params => {
      this.urlData = params;
      this.showFormName = this.urlData?.formName;
      if (this.isReadOnly) {
        this.isViewMode = true;
      }
    });
    this.commonService.formComponentData.subscribe((res: any) => {

  });
    this.jwtToken = sessionStorage.getItem('jwtToken') || '';
    this.commonService.prefillIpsaForm.subscribe((ipsaData: any) => {
    if (ipsaData?.hasOwnProperty('data')) {
    this.prefilledData = ipsaData;
    }
  }
  );

    const storedData = sessionStorage.getItem('ipsaListingPrams');
    this.listingParams = storedData ? JSON.parse(storedData) : null;
   }

  ngOnInit(): void {
    this.fetchFormResponse();
  }

  fetchFormResponse(): void {
    const endpoint = `/form/${this.urlData.formId}`;
    const payload = {
        method: 'GET',
        endpoint,
        headers: {
          'Content-Type': 'application/json',
          'x-jwt-token': this.jwtToken
        }
      };
    this.commonService.getIpsaFormStructure(payload).subscribe(res => {
      if (res){
        this.formFetchResponse = res;
        this.formFetchResponseComponent = this.formFetchResponse.components;
        this.formFetchResponseComponent.forEach((ele: any) => {
          if (ele.key === 'saveDraft'){
            if (this.urlData.isDraft === 'false'){
              ele.disabled = true;
            }else{
              ele.disabled = false;
            }
          }
          if (ele.key === 'update'){
            if (this.urlData.isDraft === 'false'){
              ele.hidden = false;
            }else{
              ele.hidden = true;
            }
          }
          if (ele.key === 'submit'){
            if (this.urlData.isDraft === 'false'){
              ele.hidden = true;
            }else{
              ele.hidden = false;
            }
          }
          if (this.isReadOnly) {
            if (ele.key === 'submit' || ele.key === 'update' || ele.key === 'saveDraft') {
              ele.hidden = true;
            }
          }
        });
        this.formTitle = res?.title;
        const token = res['x-jwt-token'];
        const formPath = this.formFetchResponse.path;
        const requestPayload = {
          endpoint: this.urlData.submissionId ? `/${formPath}/submission/${this.urlData.submissionId}` : `/${formPath}/submission`,
          headers: {
            'Content-Type': 'application/json',
            'x-jwt-token': token
          },
          requestBody: {},
          method: this.urlData.submissionId ? 'PUT' : 'POST'
        };
        sessionStorage.setItem('jwtToken', res['x-jwt-token']);

        const submissionPayload = {
          endpoint: this.urlData.submissionId ? `/${formPath}/submission/${this.urlData.submissionId}` : `/${formPath}/submission`,
          headers: {
              'Content-Type': 'application/json',
              'x-jwt-token': this.jwtToken
          },
          method: 'GET'
        };

        const formPathLower = (formPath || '').toLowerCase();
        const isImprovementForm = formPathLower.includes('improvement');
        const assessmentSubmissionId = this.urlData?.assessmentSubmissionId;
        const assessmentFormPath = isImprovementForm ? formPath.replace('improvement', 'assessment') : '';
        const assessmentSubmissionPayload = {
          endpoint: (isImprovementForm && assessmentSubmissionId && assessmentFormPath)
            ? `/${assessmentFormPath}/submission/${assessmentSubmissionId}`
            : '',
          headers: {
              'Content-Type': 'application/json',
              'x-jwt-token': this.jwtToken
          },
          method: 'GET'
        };

        const currentSubmission$ = this.commonService.getAllFormList(submissionPayload);
        const assessmentSubmission$ = (isImprovementForm && assessmentSubmissionPayload.endpoint)
          ? this.commonService.getAllFormList(assessmentSubmissionPayload)
          : of(null);

        forkJoin({
          currentSubmission: currentSubmission$,
          assessmentSubmission: assessmentSubmission$
        }).subscribe(({ currentSubmission, assessmentSubmission }: any) => {
        const currentSubmissionData = this.extractSubmissionData(currentSubmission);
        const projectedImprovementData = this.extractImprovementPrefillData(assessmentSubmission);
        const mergedPrefilledData = {
          country: this.userData?.country_id,
          sector: this.userData?.sector_id,
          msme: this.userData?.msme_id,
          ...projectedImprovementData,
          ...currentSubmissionData
        };
        makeFormioIpsa(
          res,
          requestPayload,
          mergedPrefilledData,
          (isLoading: boolean) => {
          this.contentService.loaderSubscriber.next(isLoading);
        }, (isLoading: boolean) => {
          this.contentService.message.next(isLoading);
        }, environment.baseURL,
        this.isReadOnly
        )
        .then((success: any) => {

          this.contentService.message.subscribe((messageRes: any) => {
            this.openSnackBar([messageRes?.data?.error], 3000);
          });
          if (success) {
            this.router.navigate(
              ['/prism-forms-list'],
              { queryParams: { formName: this.listingParams?.formName } }
            );
          } else {
            // Handle failure
            this.openSnackBar(['Failed to submit form.'], 2000);
          }
        }).catch((error: any) => {
          if (error?.data?.error === 'Draft Success') {
            this.router.navigate(
              ['/prism-forms-list'],
              { queryParams: { formName: this.listingParams?.formName } }
            );
          }
          this.contentService.message.subscribe((messageRes: any) => {
            this.openSnackBar([messageRes?.data?.error], 3000);
            if (messageRes?.data?.error === 'Draft Success') {
            this.router.navigate(
              ['/prism-forms-list'],
              { queryParams: { formName: this.listingParams?.formName } }
            );
          }
          });

          this.openSnackBar([error?.data?.error], 3000);
        });
      });


      }
    });
  }

  extractSubmissionData(submissionRes: any): any {
    if (!submissionRes) {
      return {};
    }
    if (submissionRes?.data && typeof submissionRes.data === 'object') {
      return submissionRes.data;
    }
    if (Array.isArray(submissionRes) && submissionRes[0]?.data) {
      return submissionRes[0].data;
    }
    return {};
  }

  extractImprovementPrefillData(assessmentSubmission: any): any {
    const assessmentData = this.extractSubmissionData(assessmentSubmission);
    if (!assessmentData || typeof assessmentData !== 'object') {
      return {};
    }
    const prefillMeta = assessmentData?.prefillMeta;
    if (prefillMeta?.indicators && Array.isArray(prefillMeta.indicators)) {
      return prefillMeta.indicators.reduce((acc: any, indicator: any) => {
        if (indicator?.improvementMirrorKey && indicator?.resultValue !== undefined) {
          acc[indicator.improvementMirrorKey] = indicator.resultValue;
        }
        return acc;
      }, {});
    }

    const { prefillMeta: _prefillMeta, ...fallbackAssessmentData } = assessmentData;
    return fallbackAssessmentData;
  }

  renderedFormKeys(): void {
    this.formFetchResponse.components.forEach((data: any) => {
      const obj = {};
      Object.assign(obj, data.key);
    });
  }

  submitform(event: any): void {
    return;
  }

  prefillForm(): void {
    const endpoint = `${this.formFetchResponse.path}/submission/${this.formSubmissionData._id}`;
    const payload = {
      endpoint,
      headers: {
          'Content-Type': 'application/json',
          'X-jwt-token': this.jwtToken
      },
      requestBody: {},
      method: 'GET'
  };

    this.commonService.prefillFormIO(payload).subscribe();
  }

  backToForm(): void {
    this.router.navigate(['/prism-forms'], {queryParams: {
      formName: this.urlData?.formName
    }});
  }
  backToPrevious(): void {
    this.router.navigate(['/prism-forms-list'], {queryParams: {
      formName: this.urlData?.formName
        ?.replace('Factory', '')
        ?.replace('Micro', '')
        ?.replace('Small', '')
        ?.replace('-', '')
        ?.replace(/\s{2,}/g, ' ')
        .trim()
    }});
  }

  scrollToSection(id: string): void {
    document.getElementsByClassName(`formio-component-${id}`)[0].scrollIntoView();
  }

  openSnackBar(data: string[], duration: number): void {
    this.snackBar.openFromComponent(SnackBarComponent, { data, duration });
  }
}
